import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from "axios";
import * as XLSX from 'xlsx';
import { APIURL } from '../../../Global';
import Select from 'react-select';
import { useAlert } from 'react-alert';
import './featurelist1.css'
import ErrorModal from './ErrorModal';
const ExcelUploader = (props) => {
    const [file, setFile] = useState(null);
    const [previewData, setPreviewData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hospitals, setHospitals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [medType, setMedtype] = useState({});
    const [fileType, setfiletype] = useState({});
    const [selectedHospital, setSelectedHospital] = useState(null);
    const [error, setError] = useState(null)
    const [previewHtml, setPreviewHtml] = useState(null)
    const alert = useAlert();
    const fileInputRef = useRef(null);
    const [showColumns, setShowColumns] = useState(false);
    const allColumns = [
        { name: 'medicine_name', mandatory: true },
        { name: 'price', mandatory: true },
        { name: 'selling_price', mandatory: true },
        { name: 'batch_number', mandatory: false },
        { name: 'qty', mandatory: true },
        { name: 'tax', mandatory: true },
        { name: 'manufacturer_name', mandatory: false },
        { name: 'manufacturing_date', mandatory: false },
        { name: 'expiry_date', mandatory: true },
        { name: 'purchase_date', mandatory: true },
        { name: 'controlled_substance', mandatory: false },
        { name: 'vendor_name', mandatory: true },
        { name: 'vendor_number', mandatory: true }
    ];

    const toggleColumns = (e) => {
        e.stopPropagation();
        setShowColumns(!showColumns);
    };

    React.useEffect(() => {
        const handleClickOutside = () => setShowColumns(false);
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const fetchHospitals = async () => {
        setLoading(true);
        try {
            const tokenString = sessionStorage.getItem("usertoken");
            const v2 = tokenString.replace(/["]+/g, "");

            const response = await axios.get(`${APIURL}/api/v1/staff/hospital-approve/`, {
                headers: { Authorization: "Token " + v2 },
                params: { status: 'approved' }
            });

            if (response.data.status === 'success') {
                setHospitals(response.data.hospitals.map(hospital => ({
                    value: hospital.id,
                    label: `${hospital.name} - ${hospital.location}`,
                    data: hospital
                })));
            }
        } catch (error) {
            console.error('Error fetching hospitals:', error);
            alert.error('Failed to load hospitals');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHospitals();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array', cellDates: true });
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

                const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: null });

                if (!jsonData || jsonData.length === 0) {
                    throw new Error('Empty or invalid Excel file');
                }

                const processedData = processExcelData(jsonData);
                setPreviewData(processedData);
                setFile(file);
                previewExcel(file)
            } catch (error) {
                console.error('File processing error:', error);
                alert.error('Error processing file: ' + error.message);
                setPreviewData(null);
                setFile(null);
            }
        };

        reader.onerror = () => {
            alert.error('Error reading file');
            setPreviewData(null);
            setFile(null);
        };

        reader.readAsArrayBuffer(file);
    };

    const processExcelData = (data) => {
        try {
            const headers = (data[0] || []).map((header, index) =>
                header || `Column ${index + 1}`
            );

            const rows = data.slice(1).filter(row =>
                Array.isArray(row) && row.some(cell => cell != null)
            );

            const processedRows = rows.map(row => {
                return headers.map((_, index) => {
                    const cell = row[index];

                    if (cell == null || cell === '') {
                        return 0;
                    }
                    if (cell instanceof Date) {
                        return formatDate(cell);
                    }
                    if (typeof cell === 'number' && cell > 1000) {
                        try {
                            const date = XLSX.SSF.parse_date_code(cell);
                            return `${date.d}-${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][date.m - 1]}`;
                        } catch {
                            return cell;
                        }
                    }

                    return cell;
                });
            });

            return { headers, data: processedRows };
        } catch (error) {
            console.error('Data processing error:', error);
            return { headers: [], data: [] };
        }
    };

    const formatDate = (date) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${date.getDate()}-${months[date.getMonth()]}`;
    };

    const uploadFile = async () => {
        if (!file || !selectedHospital || !medType) {
            alert.error('Please fill all fields');
            return;
        }

        setIsLoading(true);
        try {
            const tokenString = sessionStorage.getItem("usertoken");
            const v2 = tokenString.replace(/["]+/g, "");

            const formData = new FormData();
            formData.append('medicine_list', file);
            formData.append('healthcare_type', medType.value);
            formData.append('hospital_id', selectedHospital.value);
            formData.append('file_category', fileType.value);
            const response = await axios.post(
                `${APIURL}/api/v1/staff/medicine-bulk-upload/`,
                formData,
                {
                    headers: {
                        'Authorization': `Token ${v2}`,
                        'Content-Type': 'multipart/form-data'
                    },
                }
            );
            if (response.data.status === 'success' &&
                (!response.data.hasOwnProperty('Not uploaded') ||
                    response.data['Not uploaded']?.length === 0)) {
                alert.success('Upload successful');
                props.onHide();
            } else {
                setError({
                    ...response.data,
                    excelData: previewData
                });
            }
        } catch (error) {
            alert.error('Upload failed');
        } finally {
            setIsLoading(false);
        }
    };

    const previewExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array', cellDates: true });
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawHtml = XLSX.utils.sheet_to_html(firstSheet, {
                    raw: true,
                    dateNF: 'd-mmm'
                });

                const styledHtml = `
                    <style>
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            font-size: 14px;
                        }
                        th, td {
                            border: 1px solid #ccc;
                            padding: 8px;
                        }
                        th {
                            background-color: #f2f2f2;
                            position: sticky;
                            top: 0;
                            z-index: 1;
                        }
                        tr:hover {
                            background-color: #f9f9f9;
                        }
                    </style>
                    ${rawHtml}`;

                setPreviewHtml(styledHtml);

            } catch (error) {
                console.error(error);
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const closeModal = () => {
        setError(null);
    };

    return (
        <Modal {...props} size="lg" backdrop="static" keyboard={false} className='custom-modal'>
            <Modal.Header closeButton>
                <Modal.Title>{file?.name || 'Upload Medicines'}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ display: 'flex', flexDirection: 'column', gap: '20px', minHeight: '500px' }}>
                {/* <div style={{ width: '70%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Select medicine type</span>
                    <Select
                        value={medType}
                        onChange={setMedtype}
                        options={[
                            { value: 'ModernMedicine', label: 'Modern medicine' },
                            { value: 'Unani', label: 'Unani medicine' }
                        ]}
                        classNamePrefix="select"
                        styles={customSelectStyles}
                        placeholder="Select medicine type..."
                    />
                </div> */}

                <div style={{ width: '70%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Select Clinic</span>
                    <Select
                        value={selectedHospital}
                        onChange={setSelectedHospital}
                        options={hospitals}
                        isLoading={loading}
                        isSearchable={true}
                        styles={customSelectStyles}
                        placeholder="Select hospital..."
                    />
                </div>
                <div style={{ width: '70%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Select file category</span>
                    <Select
                        value={fileType}
                        onChange={setfiletype}
                        options={[
                            { value: 'inventory', label: 'Inventory' },
                            { value: 'cml', label: 'Client medicine list' }
                        ]}
                        classNamePrefix="select"
                        styles={customSelectStyles}
                        placeholder="Select medicine type..."
                    />
                </div>
                <div style={{ width: '70%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Select File</span>
                    <div>
                        <input
                            type="file"
                            accept=".xlsx, .xls, .csv"
                            onChange={handleFileChange}
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                        />
                        <button
                            onClick={() => fileInputRef.current.click()}
                            style={{
                                padding: '5px 10px',
                                backgroundColor: '#55479F',
                                color: 'white',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                border: 'none'
                            }}
                        >
                            Select Excel File
                        </button>
                    </div>
                </div>
                {file && <div style={{ height: '500px', width: '100%', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: previewHtml }} />}
                <label className="excel-upload-label">
                    Note <span style={{ color: 'red' }}>*</span> : Upload an Excel file with all columns (
                    <span className="excel-upload-label__link" onClick={toggleColumns}>
                        see list
                    </span>
                    ) and no blank mandatory fields, and dates formatted as YYYY-MM-DD.

                    {showColumns && (
                        <div className="excel-upload-label__tooltip">
                            <p className="excel-upload-label__tooltip-title">Required columns:</p>
                            <ul className="excel-upload-label__columns-list">
                                {allColumns.map((column) => (
                                    <li
                                        key={column.name}
                                        className={`excel-upload-label__column-item ${column.mandatory ? 'excel-upload-label__column-item--mandatory' : ''
                                            }`}
                                    >
                                        {column.name}
                                        {column.mandatory && (
                                            <span className="excel-upload-label__required-text"> (Required)</span>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                {file && <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className='add-btn' onClick={props.onHide} disabled={isLoading}>
                        Cancel
                    </button>
                    <button
                        className='add-btn'
                        onClick={uploadFile}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Uploading...' : 'Upload'}
                    </button>
                </div>}
                {error && <ErrorModal
                    errorMessage={error}
                    onClose={closeModal}
                    excelData={previewData}
                />}
            </Modal.Body>
        </Modal>
    );
};

const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        width: "250px",
        minHeight: '36px',
        fontSize: '14px',
    }),
    option: (provided) => ({
        ...provided,
        fontSize: '14px',
    })

};

export default ExcelUploader;